// Array.flat not supported by all browsers
export const flatten = (array) => [].concat.apply([], array);

export const removeDuplicates = (array) => [...new Set(array)];

export const lastElement = (array) => array && array.at(-1);

export const getFirstAndLast = (array) => {
  if (!array || array.length === 0) return {};
  if (array.length > 1) return { first: array.at(0), last: array.at(-1) };
  return { first: array.at(0), last: array.at(0) };
};

export const split = (array, index) =>
  array &&
  array.length >= index + 1 && {
    first: array.slice(0, index),
    second: array.slice(index + 1),
  };

export const getFilledArray = (length, value) => new Array(length).fill(value);

export const allElementsEquals = (array1, array2) => {
  if (
    !array1 ||
    !array2 ||
    !Array.isArray(array1) ||
    !Array.isArray(array2) ||
    array1.length !== array2.length
  )
    return false;

  return array1.every((value, index) => value === array2[index]);
};

export const sum = (array, fx) =>
  array && array.reduce((acc, current, index) => acc + fx(current, index), 0);
